<template>
  <div class="not-found-container">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <img :src="currentLogo" alt="Paystar Logo" class="paystar-logo">
      <h3 class="text-white-in-dark-mode">متاسفیم، صفحه‌ای که به دنبال آن هستید یافت نشد.</h3>
      <router-link class="btn btn-primary my-4" to="/">بازگشت به صفحه اصلی</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  data() {
    return {
      currentTheme: 'dark',
      themeCheckInterval: null
    }
  },
  computed: {
    currentLogo() {
      return this.currentTheme === 'dark'
        ? require('@/assets/new/image/logo_new_light.png')
        : require('@/assets/new/image/logo_new_dark.png');
    }
  },
  methods: {
    updateTheme() {
      this.currentTheme = window.localStorage.getItem('AppUiTheme') || 'dark';
    },
    setupStorageListener() {
      window.addEventListener('storage', (e) => {
        if (e.key === 'AppUiTheme') {
          this.updateTheme();
        }
      });

      window.addEventListener('themeChanged', () => {
        this.updateTheme();
      });

      this.themeCheckInterval = setInterval(() => {
        const newTheme = window.localStorage.getItem('AppUiTheme') || 'dark';
        if (newTheme !== this.currentTheme) {
          this.currentTheme = newTheme;
        }
      }, 100);
    }
  },
  mounted() {
    this.updateTheme();
    this.setupStorageListener();
  },
  beforeDestroy() {
    if (this.themeCheckInterval) {
      clearInterval(this.themeCheckInterval);
    }
    window.removeEventListener('storage', this.updateTheme);
    window.removeEventListener('themeChanged', this.updateTheme);
  }
}
</script>

<style scoped>
.not-found-container {
  text-align: center;
  margin: 50px auto; /* Center the component and add some margin */
  padding: 20px;
  max-width: 600px; /* Set a maximum width for responsiveness */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 2em;
  color: #333;
}

p {
  font-size: 1.2em;
  color: #555;
}

.router-link {
  color: #007BFF;
  text-decoration: underline;
  cursor: pointer;
}

.paystar-logo {
  margin-top: 20px;
  margin-bottom: 40px;
  max-width: 100%;
}
</style>